/**
 * Сервис для работы с сервисом Сдай/Сними
 */
import {
  fetchIsOfferDealCandidate
} from '../../../../shared/repositories/deal-rent-announcements/v1/is-offer-deal-candidate';

/**
 * DEPRECATED: Есть redux-селектор selectIsDealRent
 */
export const isDealRent = () =>
  window.addFormState &&
  window.addFormState.offer &&
  window.addFormState.offer.flags &&
  window.addFormState.offer.flags.isDealRent &&
  window.addFormState.offer.status === 'published';

export default [
  'httpApi', 'logger', 'config', 'addFormService', 'geoService', 'popupService',
  function (httpApi, logger, config, addFormService, geoService, popupService)
{
  const ofertaUrl = config.get('dealV2.ofertaUrl');

  let isDealV2Candidate = false;

  const getIsDealV2Candidate = () => {
    return isDealV2Candidate;
  }

  const setIsDealV2Candidate = (value) => {
    isDealV2Candidate = Boolean(value);
  }

  const checkIsDealV2Candidate = async () => {
    const { ad } = addFormService;

    const shouldCheckForCandidate =
      ad &&
      ad.bargainTerms &&
      ad.bargainTerms.leaseTermType === 'longTerm' &&
      ad.isByHomeowner &&
      ad.category === 'flatRent' &&
      (geoService.isMiMO() || geoService.isSPBAndArea());

    if (!shouldCheckForCandidate) {
      setIsDealV2Candidate(false);
      return;
    }

    if (ad && ad.dealRentData && ad.dealRentData.applyDealRentVersion === 'v2') {
      setIsDealV2Candidate(true);
      return;
    }

    if (!config.get('addformConfig.fetchIsOfferDealCandidate.enabled')) {
      setIsDealV2Candidate(false);
      return;
    }

    const timeout = config.get('addformConfig.fetchIsOfferDealCandidate.timeout') || 1000;

    try {
      const result = await fetchIsOfferDealCandidate({
        httpApi,
        parameters: {},
        config: {
          ecnhancersConfig: {
            timeout
          },
        },
      });

      if (result.statusCode === 200 && result.response.version === 'v2') {
        setIsDealV2Candidate(result.response.isDealCandidate);
        return;
      }
    } catch (error) {
      logger.error(error, {
        description: 'deal-rent-announcements v1 is-offer-deal-candidate',
        degradation:
          'Пользователь не увидит экран успеха в случае подключения сделки'
      });
    }

    setIsDealV2Candidate(false);
  };

  const addDealVersion = () => {
    // eslint-disable-next-line no-param-reassign
    addFormService.ad.dealRentData = {
      applyDealRentVersion: 'v2',
      applyDealRentSource: 'addForm',
    };
  };

  const openPopup = (popupName, onApprove) => {
    // eslint-disable-next-line no-param-reassign
    const dealRentVersion = addFormService.ad.dealRentData ? addFormService.ad.dealRentData.applyDealRentVersion : null;

    if (!dealRentVersion) {
      popupService.openPopup(popupName, { onApprove });
    }
  };

  const openTrapInFpConfirmPopup = (onApprove) => {
    openPopup('dealRentTrapInFpConfirm', onApprove);
  };

  const openTrapInFpPopup = (onApprove) => {
    openPopup('dealRentTrapInFp', onApprove);
  };

  const openSelfEmployedTrapPopup = (onApprove) => {
    openPopup('dealRentSelfEmployedTrap', onApprove);
  };


  return {
    getIsDealV2Candidate,
    checkIsDealV2Candidate,
    isDealRent,
    addDealVersion,
    openTrapInFpConfirmPopup,
    openTrapInFpPopup,
    openSelfEmployedTrapPopup,
    ofertaUrl
  };
}];
